import { render, staticRenderFns } from "./LanguagesSelect.vue?vue&type=template&id=62775c4f"
import script from "./LanguagesSelect.vue?vue&type=script&lang=js"
export * from "./LanguagesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports